import { useCallback, useEffect, useState } from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
//interfaces
import { UsuariosxPlataformaInterface } from "../../../../interfaces/UsuariosxPlataforma";
import SuccessMessage from "../../../Mensajes/SuccessMessage";

//estilos
const classes = require("./PlataformasAsignar.module.css").default;

const PlataformasAsignar = () => {
  const { idPlataforma } = useParams();
  const { sendRequest } = useFetch();
  const [usuarios, setUsuarios] = useState<UsuariosxPlataformaInterface[]>();
  const [show, setShow] = useState(false);

  //Función que trata los prueba traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setUsuarios(variable.data);
  }, []);

  //Función que trae las plataformas por usuario
  useEffect(() => {
    sendRequest(
      {
        url: "/usuarios_plataforma",
        method: "POST",
        body: { plataforma_id: idPlataforma },
      },
      transformData
    );
  }, [sendRequest, transformData, idPlataforma]);

  //Actualizar plataformas
  const guardarPlataformas = (event: any) => {
    event.preventDefault();
    sendRequest(
      {
        url: "/saveusuarios_plataforma",
        method: "POST",
        body: { plataforma_id: idPlataforma, usuarios: usuarios },
      },
      () => {
        setShow(true);
        window.scrollTo(0, 0);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!usuarios) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h1>Lista de usuarios de la plataforma {idPlataforma}</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Plataformas asignadas"
          body="Se han asigando las plataformas de manera correcta"
          onCloseHandler={() => setShow(false)}
        />
      )}
      <Form onSubmit={guardarPlataformas}>
        {usuarios.map((usuario, index) => (
          <div key={usuario.id} className="mb-3">
            <Form.Check
              type={"checkbox"}
              id={`default-checkbox`}
              label={`${usuario.nombre} ${usuario.apellido_paterno} ${
                usuario.apellido_materno ?? ""
              }`}
              style={{ textAlign: "left" }}
              defaultChecked={usuario.pivot ? true : false}
              onChange={(event) => {
                if (event.target.checked) {
                  usuarios[index]["pivot"] = {
                    usuario_id: usuario.id,
                    plataforma_id: +idPlataforma!,
                  };
                } else {
                  delete usuarios[index]["pivot"];
                }
              }}
            />
          </div>
        ))}
        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
            marginBottom: "20px",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default PlataformasAsignar;
